export default __webpack_public_path__ + "static/media/mid-k-10-thumb.61245863.png";